import { AppLayout } from "./app-layout.js";
import { Noti } from "./pages/noti.js";
import { Notis } from "./pages/notis.js";
import { PayStub } from "./pages/payStub.js";
import { NewPayStub } from "./pages/newPayStub.js";
import { PayStubDay } from "./pages/payStubDay.js";
import { Empty } from "./pages/empty";
import { NewPayStubDay } from "./pages/newPayStubDay.js";

const routes = [
  {
    path: "/",
    element: <AppLayout />,
    children: [
      {
        path: "/",
        element: <Empty />,
      },
      // {
      //   path: "/pay-stub",
      //   element: <PayStub />,
      // },
      {
        path: "/pay-stub",
        element: <NewPayStub />,
      },
      // {
      //   path: "/pay-stub-day",
      //   element: <PayStubDay />,
      // },
      {
        path: "/pay-stub-day",
        element: <NewPayStubDay />,
      },
      // {
      //   path: '/noti/:siteId',
      //   element: <Notis />
      // },
      // {
      //   path: '/noti/:siteId/v/:faqId',
      //   element: <Noti />
      // }
    ],
  },
  {
    path: "/empty",
    element: <Empty />,
  },
];

export { routes };
